import React, { useState, useEffect, useRef } from 'react';
import { getTokenInfo } from '../../../UseToken';
import { api_crud_route } from './Config';
import { reqGET, reqPUT } from '../../../Utils';

const MultipleChoice = ({idFormation, idModule, idSession, isEdit = false}) => {

  const [, set_dados] = useState(null);
	const dados = useRef(null);

  const [questions, set_questions] = useState([])
  const [question, set_question] = useState('')

  const [refresh, setRefresh] = useState(0)
  
  const handle_add_question = () => {

      if(question !== '') {
          let aux = questions
          aux.push({id: (questions.length + 1), question: question, answers: []})
          set_questions(aux)
          set_question('')
      }

  }
  
  const handle_add_new_answer = (id_question) => {


    console.log(id_question)

    //let aux = questions.filter((el) => el.id === id_question)
    //console.log(aux)

    questions.forEach((el) => {
      if(el.id === id_question) {
        el.answers.push({answer: '', value: false})
      }
    })

    setRefresh(refresh + 1)
    console.log(questions)

  }

  const handle_change_answer = (id_question, k_answer, value) => {


    console.log(id_question)
    console.log(k_answer)

    questions.forEach((el) => {
      if(el.id === id_question) {
        el.answers.forEach((el_a, k_a) => {
          if(k_a === k_answer) {
            el_a.answer = value
          }
        })
      }
    })

    setRefresh(refresh + 1)
    console.log(questions)

  }

  const handleSelectAnswer = e => {
    const { dataset } = e.target
		const { id, order } = dataset

    questions.forEach((el) => {
      if(parseInt(el.id) === parseInt(id)) {
  
        el.answers.forEach((el_a, k_a) => {
          if(parseInt(k_a) === parseInt(order)) {
            el_a.value = !el_a.value
          }
        })

      }
    })

  }

  const handleSave = () => {

      dados.current.content[0].modules.forEach((el) => {
          console.log('el', el)

          if(el.id === idModule) {
              if(el['evaluations'] === undefined) {
                  el['evaluations'] = []
              } 

              el['evaluations'][idSession] = { type: 'multiple_choice', questions: questions }

              console.log('dados', el)
              console.log('perguntas', questions)

              reqPUT(api_crud_route, dados.current)
                  .then(() => { 
                      
                  })
                  .catch((error) => console.log('error', error))
          }

      })

  }

  useEffect(() => {

    //if(isEdit === true) {
          reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${idFormation}`)
              .then(res => {
                
                if(isEdit === true) {
                  res.data[0].content[0].modules.forEach(el => {
                      if(el.id === idModule && el['evaluations'][idSession] !== undefined && el['evaluations'][idSession] !== null && el['evaluations'][idSession] !== '') {
                          console.log('questions', el['evaluations'][idSession])
                          set_questions(el['evaluations'][idSession].questions)
                      }
                  })
                }

                set_dados(dados.current = res.data[0]);

              })
              .catch(error => console.log(error))
      //}

  }, [])

  return (
      <div className='row'>
          <div className='col-8'>
              <textarea type="text" className='form-control' value={question} onChange={(e) => set_question(e.target.value)} />
              <button type="button" className='btn btn-light float-right mt-2' onClick={() => handle_add_question()} >Add</button>
          </div>
          <div className="col-4">
              <button type="button" className='form-control' onClick={() => handleSave()}>Save</button>
          </div>

          <div className='col-12'>
              <div className='row'>
                  {
                  questions.length > 0 ?
                      questions.map((el, k) => {
                          return (
                              <div key={k} className="col6 col-sm-4">
                                  <div className="card">
                                      <div className="card-header">
                                          Pergunta:
                                      </div>
                                      <div className="card-body">
                                          <span className="card-text">
                                              <p>{el.question}</p>
                                              <button type="button" className='form-control' onClick={() => handle_add_new_answer(el.id)}>adicionar resposta</button>
                                              {
                                              el.answers.map((el_a, k_a) => {
                                                return (
                                                  <div key={k_a} className="input-group my-3">
                                                    <div className="input-group-text">
                                                      <input 
                                                        id={"a_" + k + '_' + k_a}
                                                        value=""
                                                        type="checkbox" 
                                                        className='form-check-input rounded-0' 
                                                        data-id={el.id}
                                                        data-order={k_a}
                                                        onChange={handleSelectAnswer}
                                                        defaultChecked={el.value === true ? 'checked' : ''}
                                                      />
                                                    </div>
                                                    <input type="text" className='form-control rounded-0 mb-3 mb-lg-0' value={el_a.answer} onChange={(e) => handle_change_answer(el.id, k_a, e.target.value)} />
                                                  </div>
                                                  )
                                              })
                                              }
                                          </span>
                                      </div>
                                  </div>
                              </div>
                          )
                      })
                  :
                      null
                  }
              </div>
          </div>
      </div>
  )

};

export default MultipleChoice;
